import { cn } from "@gymflow/helpers";
import { Children } from "react";
import { DropdownNavProps } from "react-day-picker";

type CustomDropdownNavProps = DropdownNavProps & {
  containerClassName?: string;
  labelClassName?: string;
};

const CustomDropdownNav = ({
  children,
  containerClassName,
  labelClassName,
}: CustomDropdownNavProps) => {
  const [monthNode, yearNode] = Children.toArray(children);

  return (
    <nav
      aria-label="Calendar navigation"
      className={cn(
        "flex w-full items-center justify-center gap-2 p-2",
        containerClassName,
      )}
    >
      <div className="flex items-center justify-center rounded border px-3 py-2">
        <div className={cn("text-sm font-semibold", labelClassName)}>
          {monthNode}
        </div>
        <div
          className="ml-2 cursor-pointer text-sm font-semibold text-gray-950"
          aria-label="Select year"
        >
          {yearNode}
        </div>
      </div>
    </nav>
  );
};

export default CustomDropdownNav;
